import api from '../api/instance';
 
import { Page, MailBox, MailBoxToggleRequest } from '@testsigma/organism';
import { useInfiniteQuery, useQuery } from 'react-query';
import { PrivateURLConstants } from '@constants/private-url.constant';

const nameSpace = PrivateURLConstants.MAIL_BOXES;

const findAll = (query?, size?, page?, sort?) => {
  return api
    .get(nameSpace, {
      query,
      size,
      page,
      sort,
    })
    .then((res) => new Page<MailBox>().deserialize(res, MailBox))
    .catch((e) => {
      throw e;
    });
};

const show = (mailBoxId: number) => {
  return api
    .get(nameSpace + '/' + mailBoxId)
    .then((res) => new MailBox().deserialize(res))
    .catch((e) => Promise.reject(e));
};

const update = (id: number, mailbox: MailBox) => {
  return api
    .put(`${nameSpace}/${id}`, mailbox)
    .then((res) => {
      return new MailBox().deserialize(res);
    })
    .catch((e) => {
      throw e;
    });
};

const toggleStatus = (id: number,mailBoxToggleRequest: MailBoxToggleRequest) => {
  return api
    .put(`${nameSpace}/${id}/toggle_status`, mailBoxToggleRequest)
    .then((res) => {
      return new MailBoxToggleRequest().deserialize(res);
    })
    .catch((e) => {
      throw e;
    });
};

const MailBoxService = {
  findAll,
  show,
  update,
  toggleStatus
};

export default MailBoxService;

const useGetMailBoxes = () => {
  return useQuery(
    'mailbox-list',
    async () => {
      const response = await api.get(nameSpace);
      return response;
    },
    {
      refetchOnWindowFocus: true,
      staleTime: 10000,
    },
  );
};

export const useGetAllMails = ({ mailBoxId }: { mailBoxId: number }) =>
  useInfiniteQuery(
    'mailbox-infinite-query',
    async ({ pageParam = '' }) => {
      const url = pageParam
        ? `${PrivateURLConstants.MAIL_BOX_MESSAGE}?query=mailBoxId:${mailBoxId}&sort=id,desc&size=10&${pageParam}`
        : `${PrivateURLConstants.MAIL_BOX_MESSAGE}?query=mailBoxId:${mailBoxId}&sort=id,desc&page=0&size=10`;
      return await api.get(url);
    },
    {
      getPreviousPageParam: (firstPage: any) => {
        if (firstPage.number > 0 && firstPage.number - 1) {
          return `page=${firstPage.number - 1}`;
        } else return undefined;
      },
      getNextPageParam: (lastPage: any, allPages) => {
        if (!lastPage.last && lastPage.number + 1)
          return `page=${lastPage.number + 1}`;
        else return undefined;
      },
    },
  );
